import { render } from "./category.vue?vue&type=template&id=5c0374c0"
import script from "./category.vue?vue&type=script&lang=js"
export * from "./category.vue?vue&type=script&lang=js"

import "./category.vue?vue&type=style&index=0&id=5c0374c0&lang=scss"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__